import axios from "../utils/axios";

export function getFilters(filterType) {
  return axios.get(`/filter/getFilters?filterType=${filterType}`);
}

export function deleteFilter(id) {
  return axios.post(`/filter/deleteFilter?id=${id}`);
}
